import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          console.error("Auth callback error:", error);
          navigate("/partners/login", { replace: true });
          return;
        }

        if (!data.session?.user) {
          navigate("/partners/login", { replace: true });
          return;
        }

        const userId = data.session.user.id;
        const { data: partner } = await supabase
          .from("partners")
          .select("id")
          .eq("id", userId)
          .maybeSingle();

        sessionStorage.removeItem("partner_oauth_intent");

        if (partner) {
          navigate("/partners/dashboard", { replace: true });
          return;
        }

        navigate("/partners/organization", { replace: true });
      } catch (error) {
        console.error("Error in auth callback:", error);
        navigate("/partners/login", { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8faf9] dark:bg-gray-950">
      <div className="text-center">
        <div className="h-8 w-8 rounded-full border-2 border-skutopia-500 border-t-transparent animate-spin mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-400">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
